import moment from "moment";
import { useEffect, useState } from "react";
import { config } from "../../config";
import { GET, newFetch } from "../../helpers/fetch";
const { SERVER_URL } = config;

const ARTLogs = () => {
  const [logs, setLogs] = useState([]);

  const fetchArts = async () => {
    let api_path = `/associate/art/all`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let data = response.data;
      setLogs(data);
    }
  };

  useEffect(() => {
    fetchArts();
  }, []);

  return (
    <div className="d-flex flex-column my-3">
      <br />
      <br />
      <h5 className="text-brand text-underline">Recent Logs</h5>
      <br />
      <ul className="art-logs-wrapper">
        {logs.length > 0
          ? logs.map((log, index) => (
              <li key={index}>
                <strong>
                  {moment(log.createdAt).format("DD/MM/YYYY HH:mm")}
                </strong>{" "}
                - Click{" "}
                <a href={SERVER_URL + "/" + log.image} target="_blank">
                  here
                </a>{" "}
                to view file.
              </li>
            ))
          : "No records found."}
      </ul>
    </div>
  );
};

export default ARTLogs;
